import HorizontalListItem from './HorizontalListItem';

export default HorizontalListItem;
